.employeeAvatarWrapper {
    flex: 0 0 auto;
    padding-right: 0;
}

.chips {
    display: flex;
    flex-wrap: wrap;
    gap: var(--bi-scale-2x) var(--bi-scale-1x);

    @media (width < 768px) {
        gap: var(--bi-scale-1-5x) var(--bi-scale-1x);
    }
}

.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
